import './PageLoader.css';

const PageLoader = ({ label = 'Loading page' }) => (
  <div className="page-loader" role="status" aria-label={label}>
    <div className="page-loader__indicator">
      <div className="page-loader__ring" aria-hidden="true"></div>
      <svg
        className="page-loader__logo"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M49.7546 22.6468C54.0489 22.6468 57.5301 19.174 57.5301 14.8901C57.5301 10.6061 54.0489 7.1333 49.7546 7.1333C45.4602 7.1333 41.979 10.6061 41.979 14.8901C41.979 19.174 45.4602 22.6468 49.7546 22.6468Z"
          fill="#243A5E"
        />
        <path
          d="M53.3527 25.811C49.9375 25.811 47.1018 28.3662 46.7054 31.6818C46.7054 31.7731 46.7054 31.8947 46.7054 31.986C45.7601 40.8682 37.8321 47.682 28.5014 46.8303C20.6954 46.1307 14.3225 39.8949 13.4687 32.1381C12.432 22.9212 18.9878 14.9819 27.6781 13.7348C28.8673 13.5522 30.087 13.5523 31.2762 13.6435L32.5264 13.7348C32.8008 13.7652 33.1058 13.7956 33.3802 13.7956C37.0698 13.7956 40.058 10.8146 40.058 7.1339C40.058 3.93994 37.8016 1.26309 34.7524 0.624301C34.4474 0.563464 34.1425 0.533045 33.8376 0.502627C32.6179 0.350533 31.3372 0.259277 30.087 0.259277C13.0723 0.259277 -0.618756 14.3431 0.0215825 31.4384C0.631429 47.0737 13.4382 59.7583 29.1113 60.245C44.7843 60.7317 58.4449 48.7467 60 33.2636C60 33.1723 60 33.0506 60 32.929C60 32.7769 60 32.6248 60 32.4727C60 28.792 57.0118 25.811 53.3222 25.811H53.3527Z"
          fill="#2892D7"
        />
      </svg>
    </div>
  </div>
);

export default PageLoader;
